import { View } from 'react-native';
import { DropdownItem } from './Item';
import { DropDownItemType } from './types';

type Props = {
  items: DropDownItemType[];
  onItemPress: (title: string) => void;
};

export const DropdownList = ({ onItemPress, items }: Props) => {
  return (
    <View className="flex flex-col p-2">
      {items.map((item, index) => (
        <DropdownItem key={index} item={item} onItemPress={onItemPress} />
      ))}
    </View>
  );
};
